
const data = [
    {
        name: 'StackOverflow',
        link: 'stackoverflow.com/',
        image: '/images/stacko.svg'
    },
    {
        name: 'Yahoo',
        link: 'yahoo.com/',
        image: '/images/yahoo.svg'
    },
    {
        name: 'NASA',
        link: 'nasa.gov/',
        image: '/images/nasa.svg'
    },
    {
        name: 'Amazon',
        link: 'amazon.com/',
        image: '/images/amazon.svg'
    },
    {
        name: 'Facebook',
        link: 'facebook.com/',
        image: '/images/facebook.svg'
    },
    {
        name: 'Google',
        link: 'google.com/',
        image: '/images/google.svg'
    },
    {
        name: 'CNN',
        link: 'cnn.com/',
        image: '/images/cnn.svg'
    },
    {
        name: 'Reddit',
        link: 'reddit.com/',
        image: '/images/reddit.svg'
    },
    {
        name: 'Apple',
        link: 'apple.com/',
        image: '/images/apple.svg'
    },
    {
        name: 'IMDB',
        link: 'imdb.com/',
        image: '/images/imdb.svg'
    },
    {
        name: 'CNET',
        link: 'cnet.com/',
        image: '/images/cnet.svg'
    },
    {
        name: 'Goodreads',
        link: 'goodreads.com/',
        image: '/images/goodreads.svg'
    },
    {
        name: 'SpaceX',
        link: 'spacex.com/',
        image: '/images/spacex.svg'
    },
    {
        name: 'eBay',
        link: 'ebay.com/',
        image: '/images/ebay.svg'
    },
]

export default data